import React from 'react';
import {makeStyles} from "@mui/styles";
import {connect} from "react-redux";
import {Link} from "react-router-dom";

// MUI Imports
import {Button, Container, Paper, Typography} from '@mui/material';

// Icons
import ArrowBackIcon from '@mui/icons-material/ArrowBackIos';
import DoneIcon from '@mui/icons-material/Done';

// Actions
import {sendFlash, submitAnswers} from '../../actions/index';

const useStyles = makeStyles({
    root: {
        marginTop: '30px',
        padding: '20px'
    },
    paper: {
        padding: '40px'
    },
    buttonBox: {
        marginTop: '40px',
        display: 'flex',
        justifyContent: 'center'
    },
    button: {
        margin: '10px'
    }
});

const Consent = (props) => {
    const classes = useStyles();

    const handleGiveConsent = () => {
        let answerData = {
            userId: props.user._id,
            assessmentId: 'consent',
            totalQuestions: 1,
            answers: [1]
        }
        props.submitAnswers(answerData)
    }

    return (
        <Container maxWidth='md' className={classes.root}>
            <Paper className={classes.paper}>
                <Typography variant='h2'>
                    Informed Consent
                </Typography>
                <p align="justify">
                    <b>Confidentiality, Privileged Information, & Limitations.</b> We take confidentiality very
                    seriously and treat your information as if it were confidential health information: We will not
                    share your information with anyone except for you. Your data will be stored securely in a
                    password-protected cloud. We will keep your results for 3 years, after which it will be destroyed
                    utilizing an appropriate protocol, permanently deleting your data. Some of your answers and/or
                    results will be utilized in the final report of your assessment. If there is anything you want to
                    share, but do not wish to have recorded on your final report, please make a note of this either
                    verbally, or if writing your responses, by putting the information in brackets [like so]. There is a
                    career theory and/or research-informed rationale behind each question. Your decision to answer each
                    question is voluntary. If you do not wish to answer a question, feel free to skip it.
                </p>
                <p align="justify">
                    I understand that the information obtained in this evaluation is confidential and will not be
                    released to any person or organization without my written permission. The only exceptions to this
                    policy are rare situations in which we are required by law to release information with or without
                    client's permission. The only other reason we would break confidentiality would be to keep you or
                    others safe if we suspected you or others were in imminent danger.
                </p>
                <p align="justify">
                    If you disclose any of the following types of information in your responses, we may need to share a
                    minimal amount of your information (e.g., your name and address) to keep you and others safe:
                </p>
                <p align="justify">
                    <ol type="a">
                        <li>you disclose plan or intent to kill or cause yourself harm;</li>
                        <li>you disclose a plan or intent to hurt someone else;</li>
                        <li>you reveal any ongoing child/elder abuse or maltreatment; or</li>
                        <li>You are involved in a court case and we are ordered by a court to disclose information
                            about our work together.
                        </li>
                    </ol>
                </p>
                <p align="justify">
                    Please note: We will always do our best to disclose the least amount of information possible if any
                    of the above events occur. In some cases we will share confidential information with other
                    professionals to assist with your case (e.g., supervisors, colleagues) and some subordinates (e.g.,
                    administrators) will be given access to basic information about you (e.g., name, e-mail address) for
                    coordination of services.
                </p>
                <p align="justify">
                    <b>Diagnosis.</b> In order for insurance to be used, an accurate diagnosis must be assigned to the
                    client in order to obtain reimbursement. In the DSM-V, there are no career-related diagnoses, thus,
                    Career Assessment is not covered by insurance. In the future, if you decide to use a healthcare plan
                    to subsidize the cost of testing or future counseling, you should be aware of the following: (1)
                    Certain diagnoses can adversely affect obtaining some employment positions (e.g., government
                    positions), can be used negatively in some child custody proceedings, and can affect future health
                    care insurability; and (2) knowledge of the diagnosis is the right of the client.
                </p>
                <p align="justify">
                    <b>Testing.</b> Through the use of a variety of standard psychological tests, we will attempt to
                    answer the questions that have brought you for this assessment. These questions generally concern
                    career decision making, career functioning, personality, and/or coping styles. Throughout the
                    assessment process you have the right to inquire about the nature or purpose of all procedures. You
                    also have the right to your test results, interpretations, and recommendations. The assessment
                    process generally involves an informational interview followed by the administration of
                    psychological and career tests. Although it is sometimes possible to complete the testing procedure
                    in one sitting, it is common for people to break up the assessment battery over multiple days. Once
                    testing is completed, the data will be analyzed and a report will be written. You will then have the
                    opportunity to meet with your coach to discuss the results and receive a copy of the report.
                </p>
                <p align="justify">
                    I have read this statement, had sufficient time to be sure that I considered it carefully, asked any
                    questions via e-mail to (<a href="mailto:hello@wanderlustcareers.com">hello@wanderlustcareers.com</a>) and understood the above
                    statements. I
                    understand the limits to confidentiality required by law. I understand my rights and
                    responsibilities as a client and my assessor's responsibilities to me. I agree to undertake career
                    assessment with Wanderlust Careers. I know I can end the career assessment at any time I wish. I
                    understand that I can refuse any requests or suggestions made by Wanderlust Careers. I am over the
                    age of eighteen.
                </p>
                <div className={classes.buttonBox}>
                    <Button
                        variant="contained" component={Link} to="/" className={classes.button}
                        startIcon={<ArrowBackIcon/>}
                    >
                        Back
                    </Button>

                    <Button
                        variant="contained" color="primary" className={classes.button}
                        component={Link} to="/"
                        onClick={handleGiveConsent}
                        startIcon={<DoneIcon/>}
                    >
                        I Agree
                    </Button>
                </div>
            </Paper>
        </Container>
    )
}

const mapDispatchToProps = {
    submitAnswers,
    sendFlash
};


const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Consent);
